import React, { useState, useEffect } from 'react';
import {
  ContentNarrow, 
  ContentWide,
  ContentWrapper,
  PageSection
} from 'volto-essvoltocomponents/components/Layout';
import YouTubePlayer from '../../Atoms/YouTubePlayer';
import PDFObjectViewer from '../../Atoms/PDFObjectViewer';
import PDFJSViewer from '../../Atoms/PDFJSViewer';
import { DataTable } from '../../Atoms/Table/DataTable';

const MultimediaCompShowcase = () => {
  const [isClient, setIsClient] = useState(false);
  const [PDFJSViewer, setPDFJSViewer] = useState(null);

  // Load PDFJSViewer only on the client side after hydration
  useEffect(() => {
    setIsClient(true);
    import('../../Atoms/PDFJSViewer').then((module) => {
      setPDFJSViewer(() => module.default);
    });
  }, []);

  return (
    <PageSection>
      <ContentWrapper>
        <div className="components-showcase__header">
            <h1 className="components-showcase__title">
              Multimedia Components showcase
            </h1>
            <p className="components-showcase__description">
              Multimedia component showcase for the ESS Design System based on
              @plone/components
            </p>
        </div>

        <ContentWide>
          {/* Youtube component Section */}
          <section className="components-showcase__section">
            <h2 className="components-showcase__section-title">
              Youtube component
            </h2>
            <h4>Default dimensions (100% width and 300px height) and Youtube Embed URL</h4>
            <YouTubePlayer 
              url="https://www.youtube.com/embed/bHQqvYy5KYo"
            />
            <h4>Aspect ratio 16/9</h4>
            <YouTubePlayer 
              url="https://www.youtube.com/embed/bHQqvYy5KYo"
              aspectRatio= "16/9"
            />
            <h4>Dimensions 720x480</h4>
            <YouTubePlayer 
              url="https://www.youtube.com/embed/bHQqvYy5KYo"
              width={720}
              height={480}
            />
            <h4>Youtube standard URL</h4>
            <YouTubePlayer 
              url="https://www.youtube.com/watch?v=bHQqvYy5KYo&t=2128s"
            />
            <h4>YouTube shortened URL</h4>
            <YouTubePlayer 
              url="https://youtu.be/bHQqvYy5KYo"
            />
            <h4>Invalid YouTube URL</h4>
            <YouTubePlayer 
              url="https://www.google.com"
            />
          </section>
        </ContentWide>

        <ContentWide>
          {/*Built-in PDF viewer component Section */}
          <section className="components-showcase__section">
            <h2 className="components-showcase__section-title">
              Built-in PDF viewer component Section
            </h2>
            <ContentNarrow>
              <PDFObjectViewer url="https://ontheline.trincoll.edu/images/bookdown/sample-local-pdf.pdf"/>
            </ContentNarrow>
          </section>
        </ContentWide>

        <ContentWide>
          {/*Custom PDF viewer component (based on react-pdf) Section */}
          {isClient && (
            <section className="components-showcase__section">
              <h2 className="components-showcase__section-title">
                Custom PDF viewer component based on react-pdf
              </h2>
              <p>A standalone PDF viewer component that functions uniformly across browsers, bypasses native PDF configurations, and displays Download document button instead of the viewer in mobile view.</p>
              <p>It displays the text "Loading PDF viewer..." while loading the component</p>
              <h4>External PDF</h4>
              <ContentNarrow>
                {PDFJSViewer ? (
                    <PDFJSViewer url="https://ontheline.trincoll.edu/images/bookdown/sample-local-pdf.pdf" />
                  ) : (
                  <div>Loading PDF viewer...</div>
                )}
              </ContentNarrow>
              <h4>Internal PDF with default filename for download (the last part of the URL or "document")</h4>
              <ContentNarrow>
                {PDFJSViewer ? (
                    <PDFJSViewer url="/++api++/test/pdf-example/@@download/file" />
                  ) : (
                  <div>Loading PDF viewer...</div>
                )}
              </ContentNarrow>
              <h4>Custom width (75%)</h4>
              <ContentNarrow>
                {PDFJSViewer ? (
                  <PDFJSViewer url="/++api++/test/pdf-example/@@download/file" 
                              width="75%"/>
                  ) : (
                  <div>Loading PDF viewer...</div>
                )}
              </ContentNarrow>
              <h4>Error loading the file (non existing url in this case)</h4>
              <ContentNarrow>
                {PDFJSViewer ? (
                  <PDFJSViewer url="/++api++/test/non-existing-content/@@download/" />
                  ) : (
                  <div>Loading PDF viewer...</div>
                )}
              </ContentNarrow>
            </section>
          )}
        </ContentWide>

      {/* Table component Section */}
      <ContentWide>
        <section className="components-showcase__section">
          <h2 className="components-showcase__section-title">
            DataTable - Variants
          </h2>
          <div className="components-showcase__grid">
            <div className="components-showcase__item">
              <h3>Not stripped and with default colors</h3>
              <p> Not stripped (even and odd rows have the same bg and text colors) and with default colors for the border and the bg and text of the header row and the content rows</p>
              <DataTable 
                  headers = {["Name", "Age", "Email"]}
                  data ={[
                    { Name: "Alice", Age: 30, Email: "alice@example.com" },
                    { Name: "Bob", Age: 25, Email: "bob@example.com" },
                    { Name: "Charlie", Age: 35, Email: "charlie@example.com" }
                  ]}
                  striped = {false}
                />
              </div>
            </div>
            <div className="components-showcase__grid">
              <div className="components-showcase__item">
                <h3>Stripped with custom colors</h3>
                <p> Stripped with custom colors for the border and the bg and text of the header row, even rows and odd rows</p>
                <DataTable 
                    headers = {["Name", "Age", "Email"]}
                    data ={[
                      { Name: "Alice", Age: 30, Email: "alice@example.com" },
                      { Name: "Bob", Age: 25, Email: "bob@example.com" },
                      { Name: "Charlie", Age: 35, Email: "charlie@example.com" }
                    ]}
                    striped = {true}
                    headerBgColor = "#4CAF50"
                    headerTextColor = "#FFFFFF"
                    mainRowBgColor = "#FFFFFF"
                    mainRowTextColor = "#000000"
                    altRowBgColor = "#F2F2F2"
                    altRowTextColor = "#000000"
                    borderColor = "#DDDDDD"
                  />
              </div>
            </div>
            <div className="components-showcase__grid">
              <div className="components-showcase__item">
                <h3>Not stripped with custom colors</h3>
                <p> Not stripped with custom colors for the border and the bg and text of the header row, even rows and odd rows</p>
                <DataTable 
                    headers = {["Name", "Age", "Email"]}
                    data ={[
                      { Name: "Alice", Age: 30, Email: "alice@example.com" },
                      { Name: "Bob", Age: 25, Email: "bob@example.com" },
                      { Name: "Charlie", Age: 35, Email: "charlie@example.com" }
                    ]}
                    striped = {false}
                    headerBgColor = "#4CAF50"
                    headerTextColor = "#FFFFFF"
                    mainRowBgColor = "#FFFFFF"
                    mainRowTextColor = "#000000"
                    borderColor = "#DDDDDD"
                  />
              </div>
            </div>
            <div className="components-showcase__grid">
              <div className="components-showcase__item">
                <h3>With max width set to 600px</h3>
                <DataTable 
                    headers = {["Name", "Age", "Email"]}
                    data ={[
                      { Name: "Alice", Age: 30, Email: "alice@example.com" },
                      { Name: "Bob", Age: 25, Email: "bob@example.com" },
                      { Name: "Charlie", Age: 35, Email: "charlie@example.com" }
                    ]}
                    striped = {false}
                    maxWidth="600px"
                  />
              </div>
            </div>
            <div className="components-showcase__grid">
              <div className="components-showcase__item">
                <h3>Without data</h3>
                <DataTable 
                    headers = {["Name", "Age", "Email"]}
                    data = {[]}
                  />
              </div>
            </div>
            <div className="components-showcase__grid">
              <div className="components-showcase__item">
                <h3>With rich text content</h3>
                <DataTable 
                    headers = {["Product", "Description", "Price"]}
                    data = {[
                      {
                        Product: "Laptop",
                        Description: (
                          <p>
                            A high-performance laptop with <strong>16GB RAM</strong> and{" "}
                            <em>512GB SSD</em>.
                          </p>
                        ),
                        Price: "$1200",
                      },
                      {
                        Product: "Smartphone",
                        Description: (
                          <p>
                            A latest-gen smartphone with a <strong>6.5-inch display</strong> and{" "}
                            <em>128GB storage</em>.
                          </p>
                        ),
                        Price: "$800",
                      },
                      {
                        Product: "Headphones",
                        Description: (
                          <p>
                            Noise-cancelling headphones with <strong>Bluetooth</strong>{" "}
                            connectivity.
                          </p>
                        ),
                        Price: "$200",
                      },
                    ]}
                    striped = {false}
                  />
              </div>
            </div>
          </section>
        </ContentWide>

      </ContentWrapper>
    </PageSection>
  );
};


export default MultimediaCompShowcase;
